module.exports = __webpack_public_path__ + "static/media/reportasje.6649b7a9.mp3";